import api from '../../util/api'
import VueSimpleAlert from 'vue-simple-alert'

const state = {
  isLoggedIn: false,
}
const getters = {
  isLoggedIn: (state) => {
    return state.isLoggedIn
  },
}
const actions = {
  loginUser({ commit, dispatch }, args) {
    api
      .loginUser(args.email, args.password)
      .then(() => {
        commit('isLoggedIn', true)
        args.callback()
      })
      .catch((e) => {
        VueSimpleAlert.alert(`Failed to login: ${e}`)
        args.callback()
      })
  },
  logoutUser({ commit }, args) {
    commit('isLoggedIn', false)
    args.callback()
  },
  forceLogoutUser({ commit }) {
    commit('isLoggedIn', false)
  },
}

const mutations = {
  isLoggedIn(state, val) {
    state.isLoggedIn = val
    localStorage.isLoggedIn = val
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
